import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import AdminLayout from '../../components/admin/AdminLayout';
import { t } from 'i18next';
import instance from './../../axios/instance';
import { Button } from '@mui/material';
import { useSnackbar } from "notistack";
import Cookies from 'js-cookie';
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function AdminJobs() {
  const lang = Cookies.get("i18next") || "en";

  const { enqueueSnackbar } = useSnackbar();
  const [jobs, setJobs] = useState([]);
  useEffect(() => {
    (async () => {
      // Get all rates
      const response = await instance.get("job/accept-job");
      const data = response.data.data || [];
      setJobs(data);
    }
    )();
  },[]);
  
  async function deleteJob(id) {
    try {
      await instance.delete(`job/${id}`);
      enqueueSnackbar("تم الحذف بنجاح.", { variant: "success", autoHideDuration: "8000" });
      const response = await instance.get("job/");
      const data = response.data.data || [];
      setJobs(data);

    } catch {
      enqueueSnackbar("حدث خطأ ما", { variant: "error", autoHideDuration: "8000" });
    }
  }

  return (
    <AdminLayout>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>{t("Image Job")}</StyledTableCell>
              <StyledTableCell align="right">{t("title")}</StyledTableCell>
              <StyledTableCell align="right">{t("description")}</StyledTableCell>
              <StyledTableCell align="right">{t("Advertiser Name")}</StyledTableCell>
              <StyledTableCell align="right">{t("email")}</StyledTableCell>
              <StyledTableCell align="right">{t("phone")}</StyledTableCell>
              <StyledTableCell align="right">{t("country")}</StyledTableCell>
              <StyledTableCell align="right">{t("delete")}</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {jobs.map((job) => (
              <StyledTableRow key={job.id}>
                <StyledTableCell component="th" >
                  <img src={job.image ? `${process.env.REACT_APP_API_KEY}images/${job.image}` : "/logo.png"} alt={job.image} width={"100px"} />
                </StyledTableCell>
                <StyledTableCell align="right">
                  {lang === "ar" ?
                    <>
                      {job.titleArabic || ""}
                    </> :
                    <>
                      {job.titleEnglish || ""}
                    </>}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {lang === "ar" ?
                    <>
                      {job.descriptionArabic || ""}
                    </> :
                    <>
                      {job.descriptionEnglish || ""}
                    </>}
                </StyledTableCell>
                <StyledTableCell align="right">{job.advertiserName}</StyledTableCell>
                <StyledTableCell align="right">{job.email}</StyledTableCell>
                <StyledTableCell align="right">{job.phoneNumber}</StyledTableCell>
                <StyledTableCell align="right">{t(job.country)}</StyledTableCell>
                <StyledTableCell align="right">
                  <Button variant="contained" color='error' onClick={() => { deleteJob(job.id) }}>{t("delete")}</Button>
                </StyledTableCell>
              </StyledTableRow>
            ))} 
          </TableBody>
        </Table>
      </TableContainer>
    </AdminLayout>
  )
}

export default AdminJobs;
